import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import {NavLink, } from 'react-router-dom';
import MenuList from '@material-ui/core/MenuList';
import SearchIcon from '@material-ui/icons/Search';
import { withRouter } from "react-router-dom";
import {
    AccountTreeTwoTone,
    AssessmentTwoTone,
    ContactsTwoTone,
    DeveloperBoardTwoTone,
    DonutSmallTwoTone,
    ExpandMore,
    HomeTwoTone,
    LockOpenTwoTone, AccountCircle, SearchTwoTone,
    SupervisorAccountTwoTone, PowerTwoTone, SystemUpdateAltTwoTone
} from '@material-ui/icons';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TermsAndConditions from "./TermsAndConditions";
import ExpandLess from "@material-ui/core/SvgIcon/SvgIcon";
import Collapse from "@material-ui/core/Collapse";
import InputBase from "@material-ui/core/InputBase";
import {GreenButton} from "./common/ButtonsConstants";
import Modal from "@material-ui/core/Modal";
import * as CommonUtils from "../util/CommonUtils";
import {BOUND_USER_ID} from "../Constants";
import {exportReport} from "../util/ApiUtils";

const drawerWidth = 320;
const top = 50;
const left = 50;

const classes = (theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
    },
    toolbar: theme.mixins.toolbar,
    search: {
        //position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        //marginRight: theme.spacing(2),
        position: "absolute",
        right: "21%",
        marginLeft: 0,
        width: '100%',
        top: '20%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    clearIcon: {
        height: '100%',
        position: 'absolute',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    signOut: {
        top: '20%',
    },
}));

class Copyright extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal() {
        this.setState({
            show: false,
        });
    }
    render() {
        return (
            <div>
                <Typography variant="body2" color="textSecondary" align="center" className="App-copyright">
                    <Link href="/">Home</Link> | <Link onClick={this.showModal} style={{ cursor: "pointer" }}>Terms And Conditions</Link><br/>
                    {'Copyright © '}
                    <Link color="inherit" href="#">
                        Statuo
                    </Link>{' '}
                    {new Date().getFullYear()}
                    {'.'}
                </Typography>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.show}
                    onClose={() => this.closeModal()}
                >
                    <div style={{
                        position: 'absolute',
                        width: 1200,
                        backgroundColor: "white",
                        border: '2px solid #000',
                        //boxShadow: theme.shadows[5],
                        //padding: theme.spacing(2, 4, 3),
                        top: `${top}%`,
                        left: `${left}%`,
                        transform: `translate(-${top}%, -${left}%)`,
                    }}>
                        <TermsAndConditions user={this.props.currentUser}/>
                    </div>
                </Modal>
            </div>
        );
    }
}

const menuItems = [
    {
        name: "Context of the Organisation", icon: <AccountTreeTwoTone htmlColor='green'/>, href: '/context-of-organisation',
        children : [
            { name: "Purpose", href:  "/context-of-organisation/purpose" },
            { name: "Organisational Chart", href:  "/context-of-organisation/orgChart" },
            { name: "Scope", href:  "/context-of-organisation/scope" },
            { name: "Objectives", href:  "/context-of-organisation/objectives" },
            { name: "Policies", href:  "/context-of-organisation/policies" },
            { name: "Position Descriptions", href:  "/context-of-organisation/position-descriptions" },
            { name: "Terms and definitions", href:  "/context-of-organisation/terms-and-definitions" },
            { name: "Acronyms and Abbreviations", href:  "/context-of-organisation/acronyms-and-abbreviations" },
            { name: "References", href:  "/context-of-organisation/references" },
            { name: "Interested Parties", href:  "/context-of-organisation/interested-parties" },
            { name: "External and Internal Issues", href:  "/context-of-organisation/external-internal-issues" },
        ],
    },
    {
        name: "Leadership", icon: <SupervisorAccountTwoTone htmlColor='green'/>, href: "/leadership"
    },
    {
        name: "Planning", icon: <DonutSmallTwoTone htmlColor='green'/>, href: "/planning",
        children : [
            { name: "Comprehensive Risk Assessment", href:  "/planning/risk" },
            { name: "Legal and Other Compliance Requirements", href:  "/planning/legal-requirements" },
        ],
    },
    {
        name: "Project Management", icon: <DonutSmallTwoTone htmlColor='green'/>, href: "/project-management",
        children : [
            { name: "Project Management", href:  "/project-management/project-management" },
        ],
    },
    {
        name: "Support", icon: <ContactsTwoTone htmlColor='green'/>, href: "/support",
        children : [
            { name: "Procedure P1.0 Integrated Management Review", href:  "/support/ims" },
            { name: "Procedure P2.0 Monitoring and Measuring Resources", href:  "/support/mm-resources" },

            { name: "Procedure P3.0 Measurement and traceability", href:  "/support/measurement-and-traceability" },
            { name: "Procedure P4.0 Organisational knowledge", href:  "/support/org-knowledge" },
            { name: "Procedure P5.0 Competence", href:  "/support/competence" },
            { name: "Procedure P6.0 Awareness of ISMS documentation", href:  "/support/awareness" },
            { name: "Procedure P7.0 Communication", href:  "/support/communication" },

            { name: "Procedure P8.0 Documented Information", href:  "/support/documented-information" },
            { name: "Procedure P9.0 Training", href:  "/support/training" },

            { name: "Procedure P10.0 Property belonging to customers or external providers", href:  "/support/property-belonging" },

            { name: "Procedure P11.0 Preservation", href:  "/support/preservation" },
            { name: "Procedure P12.0 Post delivery activities", href:  "/support/post-delivery" },

            { name: "Procedure P13.0 Internal Audit", href:  "/support/internal-audit" },
            { name: "Procedure P14.0 Nonconformity and corrective action", href:  "/support/nonconformity" },
            { name: "Procedure P15.0 Continual Improvement", href:  "/support/continual-improvement" },
            { name: "Procedure P16.0 Risk Assessment", href:  "/support/risk-assessment" },
            { name: "Procedure P17.0 On-site Induction", href:  "/support/on-site-induction" },
            { name: "Procedure P18.0 Incident Notification", href:  "/support/incident-notification" },

            { name: "Procedure P19.0 Description of the incident", href:  "/support/description-of-the-incident" },

            { name: "Procedure P20.0 Incident Investigation", href:  "/support/incident-investigation" },
            { name: "Procedure P21.0 Operation", href:  "/support/operation" },
            { name: "Procedure P22.0 Personal Protective Equipment", href:  "/support/ppe" },
        ],
    },
    {
        name: "Operation", icon: <DeveloperBoardTwoTone htmlColor='green'/>, href: "/operation",
        children : [
            { name: "IMS Improvement Register", href:  "/operation/ims-improvement-register" },
            { name: "IMS Audit Checklist", href:  "/operation/ims-audit-checklist" },
            { name: "Management Review Meeting", href:  "/operation/management-review-meeting" },
            { name: "Approved Supplier List", href:  "/operation/approved-supplier" },
            { name: "Approved Contractors", href:  "/operation/approved-contractor" },
            // { name: "Electrical Equipment Register", href:  "/operation/equipment-register" },
            { name: "Audit Plan", href:  "/operation/audit-plan" },
            //{ name: "Chemical Register", href:  "/operation/msds" },
            { name: "Nonconformance / Corrective Action Register", href:  "/operation/noncomformance" },
            //{ name: "Safe Work Method Statements (SWMS)", href:  "/operation/swms" },
            { name: "Communication Plan", href:  "/operation/communication-plan" },
            { name: "Incident Notification", href:  "/operation/incident-notification-template" },
            { name: "Training Register", href:  "/operation/training-register" },
            { name: "Document Retention and Disposition", href:  "/operation/document-retention" },
            { name: "Emergency Response Testing", href:  "/operation/emergency-response-testing" },
            { name: "Asset Register Form", href:  "/operation/asset-register-form" },
            { name: "Privileged Access Form", href:  "/operation/privileged-access-form" },
        ],
    },
    {
        name: "Flowchart", icon: <SupervisorAccountTwoTone htmlColor='green'/>, href: "/flowcharts"
    },
    {
        name: "Performance evaluation/Improvement", icon: <AssessmentTwoTone htmlColor='green'/>, href: "/performance",
        children : [
            { name: "Performance Review", href:  "/performance/performance-review-template" },
        ],
    }];

class MainDecorator extends Component {
    constructor(props) {
        super(props);
        let searchTerm = sessionStorage.getItem('searchTerm');
        console.log('searchTerm', searchTerm);
        this.state = {
            searchTerm: searchTerm,
            filterMenuBy: '',
        };
        this.signOut = this.signOut.bind(this);
        this.search = this.search.bind(this);
        this.filterMenu = this.filterMenu.bind(this);
        this.routeChange = this.routeChange.bind(this);
    }

    routeChange() {
        this.props.history.push(`/search-results/${encodeURIComponent(this.state.searchTerm)}`);
        // window.location.reload();
    }

    populateMenuItems(isAuthenticated, filterMenuBy) {
        if (isAuthenticated && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(this.props.currentUser.username)) {
            /*if (menuItems.length < 8) {
                menuItems.splice(6, 0,
                    {
                        name: "Flowchart", icon: <SupervisorAccountTwoTone htmlColor='green'/>, href: "/flowcharts"
                    },
                )
            }*/
        }
        if (!isAuthenticated) {
            return [
                    {name: 'Home', icon: <HomeTwoTone htmlColor='green'/>, href: "/"},
                    {name: 'Sign In', icon: <LockOpenTwoTone htmlColor='orange'/>, href: "/sign-in"},
                    // {name: 'Sign Up', icon: <InputTwoTone/>, href: "/sign-up"},
                ];
        } else if (this.props.currentUser.hasAcceptedTermsAndConditions) {
            return menuItems.filter(
                item => {
                    if (!filterMenuBy) {
                        return true;
                    }
                    if (item.name.toLowerCase().includes(filterMenuBy.toLowerCase()) || item.href.toLowerCase().includes(filterMenuBy.toLowerCase())) {
                        return true;
                    }
                    if (item.children) {
                        for (let i = 0; i < item.children.length; i++) {
                            let child = item.children[i];
                            if (child.name.toLowerCase().includes(filterMenuBy.toLowerCase()) || child.href.toLowerCase().includes(filterMenuBy.toLowerCase())) {
                                return true;
                            }
                        }
                    }
                }
            );
        }
    }

    filterMenu(value) {
        this.setState({
            filterMenuBy: value
        });
    }

    search({ target }) {
        let searchTerm = target.value;
        console.log('search', searchTerm);
        this.setState({
            searchTerm: searchTerm
        }, sessionStorage.setItem('searchTerm', searchTerm));
    }

    signOut() {
        this.filterMenu("");
        this.props.onLogout();
    }

    showTermsAndConditions() {
        console.log('this.props.isAuthenticated', this.props.isAuthenticated);
        console.log('this.props.currentUser', this.props.currentUser);
        console.log('this.props.currentUser.hasAcceptedTermsAndConditions', (this.props.currentUser && this.props.currentUser.hasAcceptedTermsAndConditions));
        return this.props.isAuthenticated && !this.props.currentUser.hasAcceptedTermsAndConditions;
    }

    handleClick(item) {
        console.log("pushing " + item);
        this.setState( prevState => (
            { [ item ]: !prevState[ item ] }
        ) )
    }

    checkState(subOption, pathname) {
        if (pathname.startsWith(subOption.href)) {
            return true;
        }
        return this.state[ subOption.name ];
    }

    adminMenu(pathname) {
        /*return this.props.isAuthenticated && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(this.props.currentUser.username) && (<div key="admin_menu">
            <NavLink to="/admin/new-client" style={{ textDecoration: 'none', display: 'block' }} key="/admin/new-client">
                <MenuItem button key="admin_new_client" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/new-client"} >
                    <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                    <ListItemText primary="NEW CLIENT REGISTRATION" />
                </MenuItem>
            </NavLink>
        </div>);*/
        return this.props.isAuthenticated && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(this.props.currentUser.username) && (
            <div key="admin_menu">
                <MenuItem button key="admin_menu" style={{whiteSpace: 'normal'}} onClick={ () => this.handleClick( "admin_menu" ) }>
                    <ListItemIcon><PowerTwoTone htmlColor='green'/></ListItemIcon>
                    <ListItemText primary="ADMIN" />
                    { this.state[ "admin_menu" ] ?
                        <ExpandLess /> :
                        <ExpandMore />
                    }
                </MenuItem>
                <Collapse
                    in={ this.checkState({name: "admin_menu", href: "/admin"}, pathname) }
                    timeout="auto"
                    unmountOnExit
                >
                    <div key="admin_new_client">
                        <NavLink to="/admin/new-client" style={{ textDecoration: 'none', display: 'block' }} key="admin_new_client">
                            <MenuItem button key="admin_new_client" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/new-client"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary="NEW CLIENT REGISTRATION" />
                            </MenuItem>
                        </NavLink>
                    </div>
                    <div key="admin_delete_client">
                        <NavLink to="/admin/delete-client" style={{ textDecoration: 'none', display: 'block' }} key="admin_delete_client">
                            <MenuItem button key="admin_delete_client" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/delete-client"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary="DELETE A CLIENT" />
                            </MenuItem>
                        </NavLink>
                    </div>
                    <div key="admin_delete_client">
                        <NavLink to="/admin/migrate-client" style={{ textDecoration: 'none', display: 'block' }} key="admin_migrate_client">
                            <MenuItem button key="admin_migrate_client" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/migrate-client"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary="UPDATE AN EXISTING CLIENT" />
                            </MenuItem>
                        </NavLink>
                    </div>
                    <div key="admin_reset_client_password">
                        <NavLink to="/admin/reset-client-password" style={{ textDecoration: 'none', display: 'block' }} key="admin_reset_client_password">
                            <MenuItem button key="admin_reset_client_password" style={{whiteSpace: 'normal'}} selected={pathname === "/admin/reset-client-password"} >
                                <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>
                                <ListItemText primary="RESET PASSWORD" />
                            </MenuItem>
                        </NavLink>
                    </div>
                </Collapse>
            </div>)
    }

    handler( children, pathname ) {
        const { state } = this;
        /*if (children.length < 1) {
            return <div key='notFound'>
                <NavLink to='#' style={{ textDecoration: 'none', display: 'block' }} key='notFound'>
                    <MenuItem button key='notFound' style={{whiteSpace: 'normal'}}>
                        <ListItemText primary='Not Found' />
                    </MenuItem>
                </NavLink>
            </div>;

        }*/
        return (
            children.map( ( subOption ) => {
            if ( !subOption.children ) {
                return (
                    <div key={ subOption.name }>
                        <NavLink to={subOption.href} style={{ textDecoration: 'none', display: 'block' }} key={subOption.name}>
                            <MenuItem button key={subOption.name} style={{whiteSpace: 'normal'}} selected={pathname === subOption.href} >
                                { subOption.icon ? <ListItemIcon>{subOption.icon}</ListItemIcon> : <span style={{whiteSpace: 'normal', paddingLeft: "55px"}}></span>}
                                <ListItemText primary={subOption.name.toUpperCase()} />
                            </MenuItem>
                        </NavLink>
                    </div>
                )
            }
            return (
                <div key={ subOption.name }>
                    <MenuItem button key={subOption.name} style={{whiteSpace: 'normal'}} onClick={ () => this.handleClick( subOption.name ) }>
                        { subOption.icon && <ListItemIcon>{subOption.icon}</ListItemIcon>}
                        <ListItemText primary={subOption.name.toUpperCase()} />
                        { state[ subOption.name ] ?
                            <ExpandLess /> :
                            <ExpandMore />
                        }
                    </MenuItem>
                    <Collapse
                        in={ this.checkState(subOption, pathname) || this.state.filterMenuBy !== '' }
                        timeout="auto"
                        unmountOnExit
                    >
                        { this.handler( subOption.children.filter(innerChild => {
                            if (this.state.filterMenuBy === '' || innerChild.name.toLowerCase().includes(this.state.filterMenuBy.toLowerCase()) || innerChild.href.toLowerCase().includes(this.state.filterMenuBy.toLowerCase())) {
                                return true;
                            }
                        }), pathname ) }
                    </Collapse>
                </div>
            )
        } ))
    }


    render() {
        const menuItems = this.populateMenuItems(this.props.isAuthenticated, this.state.filterMenuBy);
        const { classes, location: { pathname } } = this.props;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let boundUserId = localStorage.getItem(BOUND_USER_ID);
        console.log("boundUserId", boundUserId);
        return (
            <div className={classes.root}>
                <CssBaseline />
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <Grid
                            justify="space-between" // Add it here :)
                            container
                        >
                            <Grid item>
                                <Link href="/"><img src="/images/logo.jpg" alt="Statuo" height="50px" style={{ marginLeft: "-5px" }}/></Link>
                            </Grid>
                            <Grid item>
                                { this.props.isAuthenticated &&
                                <div className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon/>
                                    </div>
                                    <InputBase
                                        placeholder="Quick Search"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        id="filterMenuBy"
                                        label="Quick Search"
                                        name="filterMenuBy"
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={e => this.filterMenu(e.target.value)}
                                    />
                                </div>}
                                {/*<div className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon/>
                                    </div>
                                    <InputBase
                                        placeholder="Search"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        value={this.state.searchTerm}
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={(newValue) => this.search(newValue)}
                                    />
                                    { this.state.searchTerm !== '' &&
                                    <div className={classes.clearIcon}>
                                        <GreenButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<SearchTwoTone/>}
                                            size="small"
                                            onClick={this.routeChange}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "right" }}
                                        >
                                            SEARCH
                                        </GreenButton>
                                    </div>}
                                </div>*/}
                            </Grid>
                            <Grid item>
                                <div style={{ position: 'absolute', right: '12%', top: '12px', width: '150px', textAlign: "right" }}>
                                    {this.props.currentUser && !this.props.currentUser.isDemo && this.props.currentUser.username === 'admin@statuo.com.au' && <React.Fragment><span style={{ textDecoration: 'none', paddingRight: "10px" }}><GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/ALL/export')} style={{ float: 'center' }}>EXPORT ALL</GreenButton></span></React.Fragment>}
                                </div>
                            </Grid>
                            <Grid item>
                                <div style={{ position: 'relative' }}>
                                    <div style={{ position: 'absolute', right: '5%', top: '8px', width: '300px', textAlign: "right" }}>
                                        {
                                            this.props.isAuthenticated
                                                ? <React.Fragment><NavLink to="/profile" style={{ textDecoration: 'none', paddingRight: "10px" }} key="profile-link"><AccountCircle htmlColor='white' style={{ display: "inline-flex", alignSelf: "center", top: ".25em", right: ".25em", position: "relative" }}/>{this.props.currentUser.name}</NavLink>{(isAuditor && boundUserId && <span style={{ color: 'red' }}>({localStorage.getItem('boundUserName')})</span>)}<Button onClick={this.signOut}>Sign Out</Button></React.Fragment>
                                                : <Button href="/sign-in">Sign In</Button>
                                        }
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>

                {((!isAuditor || (boundUserId && boundUserId !== "")) && Array.isArray(menuItems) && (menuItems.length > 0 || this.state.filterMenuBy !== '')) &&
                <React.Fragment>
                    <Drawer
                        className={classes.drawer}
                        variant="permanent"
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <div className={classes.toolbar} />
                        <MenuList>
                            { this.adminMenu(pathname) }
                            { this.handler(menuItems, pathname) }
                        </MenuList>
                    </Drawer>
                </React.Fragment>
                }
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    {
                        this.showTermsAndConditions()
                            ? <TermsAndConditions handleTAndC={this.props.onAcceptTC}/>
                            : this.props.children
                    }
                    <Copyright currentUser={this.props.currentUser}/>
                </main>
            </div>
        )
    };
}

MainDecorator.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    onLogout: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
    onAcceptTC: PropTypes.func.isRequired,
};

export default withStyles(classes)(withRouter(MainDecorator));
